import React from 'react';
import PropTypes from 'prop-types';

// TODO: move client-conf here as a childContextType

class Provider extends React.Component {
  getChildContext() {
    return {
      store: this.props.store,
      router: this.props.router,
    };
  }

  render() {
    return this.props.children;
  }
}

Provider.childContextTypes = {
  store: PropTypes.object,
  router: PropTypes.object,
};

Provider.propTypes = {
  store: PropTypes.object,
  router: PropTypes.object,
  children: PropTypes.object,
};

export default Provider;



// WEBPACK FOOTER //
// ./src/_app/components/Provider.jsx